import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, subscriptionDiscountsFeatureKey } from './subscription-discounts.reducer';

export const getState = createFeatureSelector<State>(subscriptionDiscountsFeatureKey);

export const getIsLoading = createSelector(getState, state => state.isLoading);
export const getIsLoaded = createSelector(getState, state => state.isLoaded);
export const getShippingDiscounts = createSelector(getState, state => state.discounts?.shipping);
